export default __webpack_public_path__ + "assets/front/scss/error.a37843a753ee2dbed1e9855be380cb86.css";